import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import { map, uniqueId } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { Button } from './styled-components/radioButtonStyles';

export const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  border: 2px solid #f06478;
  padding-top: 15px;
  padding-bottom: 15px;

  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-focus-ring-color: rgba(0, 0, 0, 0);
  ${({ error, theme }) => {
    if (error) {
      return `
        border: 3px solid ${theme.danger}
      `;
    }
    return 'border: 0';
  }};
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;

  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-focus-ring-color: rgba(0, 0, 0, 0);
`;

const Label = styled.div`
  font-size: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  line-height: ${props => (props.isCustom ? 'unset' : '16px')};
  cursor: pointer;
`;

const Text = styled.span`
  padding-top: 3px;
  padding-right: 20px;
`;

const TickWrapper = styled.div`
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  cursor: ${({ pointerCursor }) => (pointerCursor ? 'pointer' : 'unset')};
  padding: ${({ padding }) => padding};
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  text-align: center;
`;

const Tick = styled.div`
  &:before {
    content: '\\00d7';
  }
  font-weight: bold;
  font-size: calc(${({ height }) => height} - 10px);
`;

const NoTick = styled.div`
  &:before {
    content: '';
  }
  height: 100%;
`;

const CustomRadioButton = props => (
  <ButtonGroup error={props.error} style={props.styles.container}>
    {map(props.data, (button, index) => (
      <Buttons key={`${uniqueId('radioButton')}.${index}`} style={props.styles.buttonContainer}>
        <Label
          isCustom
          htmlFor={`${uniqueId('button_')}.${button.value}`}
          onClick={() => props.onChange(button.value)}
        >
          <Text style={props.styles.label}>
            <FormattedMessage id={button.text} />
          </Text>
          <Button
            onChange={() => props.onChange(button.value)}
            id={`${uniqueId('button_')}.${button.value}`}
            name={props.name}
            isCustom
            checked={props.selectedIndex === index}
            type="radio"
            value={button.value}
          />
          <TickWrapper {...props} style={props.styles.button}>
            {props.selectedIndex === index ? <Tick height={props.height} /> : <NoTick />}
          </TickWrapper>
        </Label>
      </Buttons>
    ))}
  </ButtonGroup>
);

CustomRadioButton.defaultProps = {
  padding: '',
  error: false,
  width: '44px',
  height: '44px',
  background: '#f8ecdc',
  color: '#000',
  styles: {
    container: {},
    buttonContainer: {},
    label: {},
    button: {},
  },
};

CustomRadioButton.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  error: PropTypes.bool,
  padding: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  background: PropTypes.string,
  color: PropTypes.string,
  styles: PropTypes.shape({
    container: PropTypes.object,
    buttonContainer: PropTypes.object,
    label: PropTypes.object,
    button: PropTypes.object,
  }),
};

export default CustomRadioButton;
